/**
 *
 */
const setupPhysiciansFilters = () =>
{
	/**
	 *
	 * @type {SpecialtyArea[]}
	 */
	const specialties    = [];
	const form           = document.querySelector( '.physicians-page-content .filters form' );
	const clearBtn       = document.querySelector( '.physicians-page-content .filters form button.clear' );
	const lastNameInput  = document.querySelector( '#filter-last-name' );
	const specialtyInput = document.querySelector( '#filter-specialty' );
	const specialtyElems = document.querySelectorAll( '.physicians-page-content .physicians-by-specialty .specialty' );


	if (!(form instanceof HTMLElement)) {
		return;
	}

	specialtyElems.forEach( /** @param {HTMLElement} specialtyElem */specialtyElem =>
	{
		const physicians        = [];
		const physicianElements = specialtyElem.querySelectorAll( '.physicians .physician' );

		physicianElements.forEach( physicianElem =>
		{
			physicians.push( {
				element:   physicianElem,
				title:     physicianElem.dataset.title,
				lastName:  physicianElem.dataset.lastName,
				id:        physicianElem.dataset.id,
				specialty: physicianElem.dataset.specialty,
			} );
		} );

		specialties.push( {
			element:    specialtyElem,
			slug:       specialtyElem.dataset.slug,
			physicians: physicians,
		} );
	} );

	/**
	 *
	 * @return {SpecialtyArea[]}
	 */
	const getFilteredSpecialtyAreas = () =>
	{
		const lastNameValue            = lastNameInput.value.trim();
		const specialtyValue           = specialtyInput.value;
		const lastNameRegex            = new RegExp( lastNameValue, 'i' );
		const eliminatedSpecialtySlugs = [];
		const filteredSpecialties      = [];

		specialties.forEach( specialty =>
		{
			const eliminatedPhysicianIds = [];
			const filteredSpecialty      = {
				element:    specialty.element,
				slug:       specialty.slug,
				physicians: [],
			};

			specialty.physicians.forEach( physician =>
			{
				if (lastNameValue !== '' && !lastNameRegex.test( physician.lastName )) {
					eliminatedPhysicianIds.push( physician.id );
				}
			} );

			if (eliminatedPhysicianIds.length === specialty.physicians.length) {
				eliminatedSpecialtySlugs.push( specialty.slug );
			}

			if (specialtyValue !== '') {
				if (specialty.slug !== specialtyValue) {
					eliminatedSpecialtySlugs.push( specialty.slug );
				}
			}

			filteredSpecialty.physicians = specialty.physicians.filter( physician =>
			{
				return eliminatedPhysicianIds.indexOf( physician.id ) === -1;
			} );

			if (eliminatedSpecialtySlugs.indexOf( specialty.slug ) === -1) {
				filteredSpecialties.push( filteredSpecialty );
			}
		} );

		return filteredSpecialties;
	};


	/**
	 *
	 */
	const draw = () =>
	{
		const filteredSpecialties = getFilteredSpecialtyAreas();
		const show                = elem => elem.classList.remove( 'visually-hidden' );
		const hide                = elem => elem.classList.add( 'visually-hidden' );

		specialties.forEach( specialty =>
		{
			hide( specialty.element );
			specialty.physicians.forEach( p => hide( p.element.parentElement ) );
		} );

		filteredSpecialties.forEach( specialty =>
		{
			show( specialty.element );
			specialty.physicians.forEach( p => show( p.element.parentElement ) );
		} );
	};


	form.addEventListener( 'submit', e =>
	{
		e.preventDefault();
		draw();
	} );

	clearBtn.addEventListener( 'click', e =>
	{
		lastNameInput.value = specialtyInput.value = '';

		e.preventDefault();
		draw();
	} );
};


/**
 *
 */
export default setupPhysiciansFilters;